export const PRODUCTION_PIE_DATA = [
	{ name: 'Fazenda Formigueiro', value: 62, color: '#2196F3' },
	{ name: 'Fazenda Esperança', value: 28, color: '#FF9800' },
	{ name: 'Fazenda Rio-Branco', value: 10, color: '#4CAF50' },
];

export const PROPERTIES_LINE_DATA = [
	{ day: '01', atual: 0, anterior: 0 },
	{ day: '02', atual: 1, anterior: 1 },
	{ day: '03', atual: 1, anterior: 2 },
	{ day: '04', atual: 2, anterior: 3 },
	{ day: '05', atual: 2, anterior: 3 },
	{ day: '06', atual: 2, anterior: 3 },
];
